import { createRootRoute } from '@tanstack/react-router'

import { App } from './App'

export const appRoute = createRootRoute({
    component: App,
})
